(() => {
  if (window.UnionClubHub) return;
  window.UnionClubHub = true;
  const selectPlace = button => {
    const section = button.closest('[data-union-places]');
    const lat = Number(button.dataset.lat), lon = Number(button.dataset.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lon) || Math.abs(lat)>90 || Math.abs(lon)>180 || !button.dataset.lat.trim() || !button.dataset.lon.trim()) return;
    const map = section.querySelector('[data-union-map]'), link = section.querySelector('[data-union-map-link]');
    if (!map) return;
    section.querySelectorAll('[data-union-place]').forEach(item => {
      const active = item === button;
      item.setAttribute('aria-pressed', String(active));
      item.setAttribute('aria-expanded', String(active));
      item.closest('.union-place')?.classList.toggle('is-active', active);
    });
    const url = new URL('https://www.openstreetmap.org/export/embed.html');
    url.searchParams.set('bbox', [lon-.08,lat-.05,lon+.08,lat+.05].join(','));
    url.searchParams.set('layer', 'mapnik');
    url.searchParams.set('marker', [lat,lon].join(','));
    map.src = url.href;
    if (link) link.href = button.dataset.directions || `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=13/${lat}/${lon}`;
    const name = section.querySelector('[data-union-map-name]');
    const region = section.querySelector('[data-union-map-region]');
    if (name) name.textContent = button.dataset.name || '';
    if (region) {
      const language = document.documentElement.dataset.unionLanguage || document.documentElement.lang || 'es';
      region.textContent = language.toLowerCase().startsWith('en') ? (button.dataset.regionEn || '') : (button.dataset.regionEs || '');
    }
  };
  const agendaLanguage = () => (document.documentElement.lang || 'en').toLowerCase().startsWith('es') ? 'es' : 'en';
  const selectAgendaEvent = button => {
    const section = button.closest('[data-union-agenda]');
    const image = section?.querySelector('[data-union-agenda-image]');
    if (!section || !image) return;

    section.querySelectorAll('[data-union-agenda-event]').forEach(item => {
      const active = item === button;
      item.setAttribute('aria-pressed', String(active));
      item.setAttribute('aria-expanded', String(active));
      item.closest('[data-union-agenda-item]')?.classList.toggle('is-active', active);
    });

    const language = agendaLanguage();
    const alt = language === 'es' ? button.dataset.altEs : button.dataset.altEn;
    const source = button.dataset.imageSrc;
    image.alt = alt || '';
    if (!source || image.getAttribute('src') === source) return;

    image.classList.add('is-changing');
    window.setTimeout(() => {
      image.addEventListener('load', () => image.classList.remove('is-changing'), { once: true });
      image.src = source;
    }, 140);
  };
  document.addEventListener('click', event => {
    const playButton = event.target.closest('[data-union-podcast-play]');
    if (playButton) {
      const video = document.getElementById(playButton.getAttribute('aria-controls'));
      if (video instanceof HTMLVideoElement) video.play().catch(() => {
        video.focus();
      });
    }
    const placeButton = event.target.closest('[data-union-place]');
    if (placeButton) selectPlace(placeButton);
    const agendaButton = event.target.closest('[data-union-agenda-event]');
    if (agendaButton) selectAgendaEvent(agendaButton);
  });
  document.addEventListener('pointerover', event => {
    if (!matchMedia('(hover:hover)').matches) return;
    const button = event.target.closest('[data-union-place]');
    if (button) selectPlace(button);
  });
  const syncPodcast = event => {
    if (!(event.target instanceof HTMLVideoElement)) return;
    const overlay = event.target.closest('.union-podcast')?.querySelector('[data-union-podcast-overlay]');
    if (overlay) overlay.hidden = !event.target.paused && !event.target.ended;
  };
  ['play','pause','ended','error'].forEach(type => document.addEventListener(type, syncPodcast, true));
  document.addEventListener('union:languagechange', () => {
    document.querySelectorAll('[data-union-agenda]').forEach(section => {
      const active = section.querySelector('[data-union-agenda-event][aria-pressed="true"]');
      const image = section.querySelector('[data-union-agenda-image]');
      if (!active || !image) return;
      image.alt = agendaLanguage() === 'es' ? (active.dataset.altEs || '') : (active.dataset.altEn || '');
    });
    document.querySelectorAll('[data-union-podcast-image]').forEach(image => {
      image.alt = agendaLanguage() === 'es' ? (image.dataset.altEs || '') : (image.dataset.altEn || '');
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const button = event.target?.querySelector?.('[data-union-agenda-event]');
    if (button) selectAgendaEvent(button);
  });
  document.addEventListener('toggle', event => {
    const current = event.target;
    if (!(current instanceof HTMLDetailsElement) || !current.open) return;
    const accordion = current.closest('[data-union-faq]');
    if (!accordion) return;
    accordion.querySelectorAll('details[open]').forEach(item => {
      if (item !== current) item.open = false;
    });
  }, true);
})();
